import React from "react";
import { Card, CardHeader } from "@/components/ui/card";
import { LOGO_PAGE_TITLE_DATA } from "@/assets/logoInline";
import { useTenant } from "@/contexts/TenantContext";

export default function PageTitleCard({ title }) {
  // MA-TENANTCONTEXT-ACCOUNT-METADATA-CONSOLIDATION-001: Use consolidated account metadata from TenantContext
  const { currentAccountName, loading } = useTenant();
  
  const displayName = loading || !currentAccountName ? "Loading..." : currentAccountName;

  return (
    <Card className="glass" data-testid="page-title-card">
      <CardHeader className="px-2 py-0">
        <div className="flex items-center gap-0">
          <img
            src={LOGO_PAGE_TITLE_DATA}
            alt="Logo"
            className="h-[120px] w-auto shrink-0"
            width={287}
            height={120}
            loading="eager"
            decoding="async"
            fetchPriority="high"
            data-testid="page-title-logo"
          />
          <div className="grid h-[120px] grid-rows-[1fr_8px_1fr]">
            <div className="flex flex-col justify-end">
              <div
                className="text-sm font-semibold leading-none text-indigo-600 mb-[-2px]"
                data-testid="page-title-brand"
              >
                {displayName}
              </div>
            </div>
            <div aria-hidden />
            <div className="flex flex-col justify-start">
              <h1
                className="text-xl font-semibold tracking-tight text-slate-100 sm:text-2xl lg:text-3xl"
                data-testid="page-title"
              >
                {title}
              </h1>
            </div>
          </div>
        </div>
      </CardHeader>
    </Card>
  );
}
